<template>
 

  <div class="container put-right" style="direction:rtl">

      <h3 class="heading" style="display:initial;margin-left:2rem">الاسئلة</h3>
       <!-- <form style="display:initial;">
 <router-link to="/AddComplain"> <button type="button" class="btn btn-primary">اضافة</button> </router-link>
      </form> -->


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col">  السؤال </th>
      <th scope="col"> الجواب </th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >          
      <th scope="row" >{{keey.id}}</th>
      <td>       {{keey.questinon}} </td>
      <td>       {{keey.answer}} </td>
      
     
    
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:"QuizView",
props:['id'],
data(){
  return{
     formdata2:[], 
  }
},

mounted() {
  
 
    
       fetch(geturl()+"records/question/?record="+this.id, {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data  
      })

      
    }
}
</script>

<style>

</style>